import { render, staticRenderFns } from "./ForumList.vue?vue&type=template&id=5d5ead3c&scoped=true&"
import script from "./ForumList.vue?vue&type=script&lang=js&"
export * from "./ForumList.vue?vue&type=script&lang=js&"
import style0 from "./ForumList.vue?vue&type=style&index=0&id=5d5ead3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5ead3c",
  null
  
)

export default component.exports